import { createAction } from '@reduxjs/toolkit';
import { ContractTransaction, providers } from 'ethers';
import { transactionsSlice } from './slice';

export const { setCompletedTransaction, addTransaction, clearTransactions } = transactionsSlice.actions;

interface PendingInfoTransaction {
  tx: ContractTransaction;
  summary: string;
  completeMessage?: string;
  errorMessage?: string;
}
export const addPendingTransaction = createAction<PendingInfoTransaction>('transactions/add_pending');

type CheckPendingTx = (provider: providers.Web3Provider) => { payload: providers.Web3Provider };

export const checkPendingTransactions = createAction<CheckPendingTx>(
  'transactions/check_pending_tx',
  (provider: providers.Web3Provider) => ({
    payload: provider,
  }),
);
